<list-view [liste]="geographieService.listeAdresses" *ngIf="geographieService.listeAdresses"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>